import { IconType } from "react-icons";
import {
  MdAccountBalanceWallet,
  MdAdminPanelSettings,
  MdCategory,
  MdCreditCard,
  MdDashboard,
  MdEventNote,
  MdMenuBook,
  MdPayments,
  MdPeople,
  MdPointOfSale,
  MdReceiptLong,
  MdSchool,
  MdSettings,
  MdStorefront,
} from "react-icons/md";
import { moduleRoutes } from "./Config/moduleRoutes";
import { useAuth } from "./hooks/useAuth";
import { Module } from "./models/UserRole.model";
import { useEffect, useState } from "react";

type NavItemTypeWithoutChild = {
  label: string;
  path: string;
  icon: IconType;
  children?: never;
};

type NavItemTypeWithChild = {
  label: string;
  path?: never;
  icon: IconType;
  children?: {
    label: string;
    path: string;
    icon: IconType;
  }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const navigation: NavItemType[] = [
  {
    label: "Dashboard",
    icon: MdDashboard,
    path: "/dashboard",
  },
  {
    label: "Users",
    icon: MdPeople,
    path: "/admin",
  },
  {
    label: "Order",
    icon: MdReceiptLong,
    path: "/offline-order",
  },
  {
    label: "Future Purchase",
    icon: MdEventNote,
    path: "/future-purchase",
  },
  // {
  //   label: "Product Management",
  //   icon: MdDashboard,
  //   path: "/product-management",
  // },
  {
    label: "Franchise",
    icon: MdStorefront,
    path: "/franchise",
  },
  {
    label: "Student",
    path: "/student",
    icon: MdSchool,
  },
  {
    label: "Advance Payment",
    icon: MdPayments,
    path: "/advance-payment",
  },
  // {
  //   label: "Payments",
  //   icon: MdPayments,
  //   path: "/payments",
  // },
  {
    label: "Dues",
    icon: MdAccountBalanceWallet,
    path: "/dues",
  },
  {
    label: "Drawer",
    icon: MdPointOfSale,
    path: "/drawer",
  },
  {
    label: "Configuration",
    icon: MdSettings,
    children: [
      {
        label: "Payment Mode",
        path: "/payment-mode",
        icon: MdCreditCard,
      },

      {
        label: "User Role",
        path: "/user-role",
        icon: MdAdminPanelSettings,
      },
      // {
      //   label: "Course",
      //   path: "/course",
      //   icon: MdMenuBook,
      // },
      // {
      //   label: "Book",
      //   path: "/book",
      //   icon: MdMenuBook,
      // },
      // {
      //   label: "Expense Category",
      //   path: "/expense-category",
      //   icon: MdCategory,
      // },
      // {
      //   label: "Level",
      //   path: "/level",
      //   icon: VscGraph,
      // },
      // {
      //   label: "Subject",
      //   path: "/subject",
      //   icon: PiBook,
      // },
      // {
      //   label: "Faculty",
      //   path: "/faculty",
      //   icon: FaUsers,
      // },
      // {
      //   label: "Mode",
      //   path: "/mode",
      //   icon: IoInvertMode,
      // },
      // {
      //   label: "Course Type",
      //   path: "/course-type",
      //   icon: IoIosBook,
      // },
      // {
      //   label: "Attempt",
      //   path: "/attempt",
      //   icon: IoIosBook,
      // },
    ],
  },
];

// src/config/navigation.ts
export const useNavigationConfig = (): NavItemType[] => {
  const { getAvailableModules, isLoading } = useAuth();
  const [filteredNavigation, setFilteredNavigation] = useState<NavItemType[]>(
    []
  );
  useEffect(() => {
    if (!isLoading) {
      const availableModules: Module[] = getAvailableModules();

      const filtered = navigation
        .map((navItem) => {
          // Direct route
          if (navItem.path) {
            const moduleId = moduleRoutes[navItem.path];
            const hasAccess = availableModules.some(
              (m) => m.moduleId === moduleId
            );
            return hasAccess ? navItem : null;
          }

          // With children
          if (navItem.children) {
            const allowedChildren = navItem.children.filter((child) => {
              const moduleId = moduleRoutes[child.path];
              return availableModules.some((m) => m.moduleId === moduleId);
            });

            if (allowedChildren.length > 0) {
              return { ...navItem, children: allowedChildren };
            }
          }

          return null;
        })
        .filter(Boolean) as NavItemType[];

      setFilteredNavigation(filtered);
    }
  }, [isLoading]);

  return isLoading ? [] : filteredNavigation;
};
